module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-kyushu-4-2654c7171e5f8027a2a7248e48baa6bc.jpg";